module.exports = __webpack_public_path__ + "assets/img/1220scanqrcode-btn.4218fc4d.png";